import { DeliveryTrackingDto } from '../dtos/tracking';
import { DriverDetails } from '../models/deliveries';

export function dtoToCaptainDetails(deliveryTracking: DeliveryTrackingDto): DriverDetails | undefined {
  const captain = deliveryTracking?.captain;
  if (!captain) {
    return undefined;
  }
  return {
    driverName: captain.name,
    driverNumber: captain.phone_number,
    driverPicture: captain.image_url,
    notesToDriver: ''
  };
}
